import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Production module landing page.
 *
 * Owner (2026-10-05/06): the department pages show MODULES, one card per module, the
 * same cards as the Workflows catalog (DeptLandingSections); a card shows only when the
 * person may open it. The Reports & KPI card opens the KPI hub on this department's tab.
 * No "coming soon" note. The route is gated by dept.production in allRoutes.js.
 */
const MODULES = ["display", "di", "app-mafia", "tasks", "time", "dms", "epo", "app-tooltracker", "kpi"];

const Production = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-tools-line"
                        eyebrow="Shop Floor"
                        title="Production"
                        subtitle="Shop floor activity and run-rate insights"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Production" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="production" title="Production modules" icon="ri-tools-line" />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Production;
